import { PaginatedResult } from '../../models/paginatedResult';
import { client } from '../client';
import { FetchArg } from '../rtk-queries/queryApiCreator';
import RequestService, { NextPageParam, getNextPageURL, getQueryURL } from './requestService';

export default class RequestTreeService<T extends { id: string | number }, U extends string> extends RequestService<T, U> {

    get getNextPage() {
        return (param: Omit<NextPageParam, 'endpoint'>) => getNextPageURL({ endpoint: this.serviceName, ...param });
    }
    treeList = async (registerId: string | number, fetchArgs?: FetchArg<T>) =>
        client.get<PaginatedResult<T>>(getQueryURL(`${this.serviceName}/tree_list`, { 
            registerId, 
            q: fetchArgs?.query,
            ...fetchArgs?.param,
            }));
    treeChildrens = async (id: string | number, fetchArgs?: FetchArg<T>) =>
        client.get<PaginatedResult<T>>(
            getQueryURL(`${this.serviceName}/tree/${encodeURIComponent(id)}/childrens`, { 
                q: fetchArgs?.query,
                ...fetchArgs?.param,
             }));
}
